import { render, staticRenderFns } from "./versionData__list.vue?vue&type=template&id=ee89bbe0"
import script from "./versionData__list.vue?vue&type=script&lang=js"
export * from "./versionData__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports